module.exports = __webpack_public_path__ + "static/media/USD.bd979e81.svg";